import { render } from "./gmAbnormalCallList.vue?vue&type=template&id=59d550b5&scoped=true"
import script from "./gmAbnormalCallList.vue?vue&type=script&lang=js"
export * from "./gmAbnormalCallList.vue?vue&type=script&lang=js"

import "./gmAbnormalCallList.vue?vue&type=style&index=0&id=59d550b5&scoped=true&lang=css"
import "./gmAbnormalCallList.vue?vue&type=style&index=1&id=59d550b5&lang=css"
script.render = render
script.__scopeId = "data-v-59d550b5"

export default script